import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Button, Col, Row } from "reactstrap";

import { BsWallet2 } from "react-icons/bs";
import {
  FaExchangeAlt,
  FaMoneyBillWave
} from "react-icons/fa";
import { FaMoneyBillTransfer, FaRegMoneyBill1 } from "react-icons/fa6";
import { IoCashOutline } from "react-icons/io5";
import { encryptStorage } from "../../constants/EncryptStorage";
import { GetLanguageString } from "../helper/Components";
import { ApiFinance } from "./ApiFinance";

const QuickManageFund = ({ history }) => {
  const unitTypeName = encryptStorage.getItem("unitTypeName");
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [balances, setBalances] = useState({
    cashAccountBalance: 0,
    amanatAccountBalance: 0,
  });
  const [loadingBalances, setLoadingBalances] = useState(true);

  useEffect(() => {
    ApiFinance()
      .GetCashToAmanatTransferData(loggedInUnitId)
      .then((res) => {
        if (res.data) {
          setBalances({
            cashAccountBalance: res.data.cashAccountBalance || 0,
            amanatAccountBalance: res.data.amanatAccountBalance || 0,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching balances in QuickManageFund:", err);
      })
      .finally(() => {
        setLoadingBalances(false);
      });
  }, [loggedInUnitId]);

  return (
    <>
      <style>{`
        .balance-card-hover:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(0,0,0,0.08) !important;
        }
        @keyframes bounce-dots {
          0%, 80%, 100% { transform: scale(0); }
          40% { transform: scale(1.0); }
        }
        .bouncing-loader {
          display: flex;
          align-items: center;
          height: 24px;
          margin-top: 4px;
        }
        .bouncing-loader span {
          width: 8px;
          height: 8px;
          margin: 0 3px;
          background-color: currentColor;
          border-radius: 50%;
          display: inline-block;
          animation: bounce-dots 1.4s infinite ease-in-out both;
        }
        .bouncing-loader span:nth-child(1) { animation-delay: -0.32s; }
        .bouncing-loader span:nth-child(2) { animation-delay: -0.16s; }
      `}</style>
      <div className="wrapper wrapper-content wrapper-custom">
        {/* Elegant side-by-side KPI Balance Cards */}
        <Row style={{ marginBottom: "0px" }}>
          <Col md="6" sm="12" className="mb-3">
            <div 
              style={{ 
                padding: "12px 20px", 
                backgroundColor: "#ffffff", 
                borderRadius: "8px", 
                border: "1px solid #e7eaec", 
                borderLeft: "5px solid #1ab394", 
                boxShadow: "0 4px 6px rgba(0,0,0,0.03)", 
                transition: "transform 0.2s, box-shadow 0.2s",
                display: "flex", 
                justifyContent: "space-between", 
                alignItems: "center"
              }}
              className="balance-card-hover"
            >
              <div>
                <div style={{ fontSize: "11px", textTransform: "uppercase", color: "#888888", fontWeight: "600", letterSpacing: "0.5px" }}>
                  <GetLanguageString props="cash_account_balance" />
                </div>
                <div style={{ fontSize: "24px", fontWeight: "700", marginTop: "4px", color: "#1ab394" }}>
                  {loadingBalances ? (
                    <div className="bouncing-loader">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  ) : (
                    new Intl.NumberFormat().format(balances.cashAccountBalance)
                  )}
                </div>
              </div>
              <div style={{ backgroundColor: "#e8f7f4", padding: "10px", borderRadius: "50%" }}>
                <IoCashOutline style={{ color: "#1ab394", fontSize: "26px" }} />
              </div>
            </div>
          </Col>

          <Col md="6" sm="12" className="mb-3">
            <div 
              style={{ 
                padding: "12px 20px", 
                backgroundColor: "#ffffff", 
                borderRadius: "8px", 
                border: "1px solid #e7eaec", 
                borderLeft: "5px solid #3b82f6", 
                boxShadow: "0 4px 6px rgba(0,0,0,0.03)", 
                transition: "transform 0.2s, box-shadow 0.2s",
                display: "flex", 
                justifyContent: "space-between", 
                alignItems: "center"
              }}
              className="balance-card-hover"
            >
              <div>
                <div style={{ fontSize: "11px", textTransform: "uppercase", color: "#888888", fontWeight: "600", letterSpacing: "0.5px" }}>
                  <GetLanguageString props="transactions_amanat_account_balance" />
                </div>
                <div style={{ fontSize: "24px", fontWeight: "700", marginTop: "4px", color: "#3b82f6" }}>
                  {loadingBalances ? (
                    <div className="bouncing-loader">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  ) : (
                    new Intl.NumberFormat().format(balances.amanatAccountBalance)
                  )}
                </div>
              </div>
              <div style={{ backgroundColor: "#eff6ff", padding: "10px", borderRadius: "50%" }}>
                <BsWallet2 style={{ color: "#3b82f6", fontSize: "24px" }} />
              </div>
            </div>
          </Col>
        </Row>

        <div className="ibox">
          <div className="ibox-content panel-body">
            <h3>{<GetLanguageString props="transactions_income" />}</h3>

            <Row>
              <Col xl="1" className="text-center">
                <Button
                  className="btn-danger dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/addInfaqCashInHand`,
                    })
                  }
                >
                  <FaRegMoneyBill1 size={50} />
                </Button>
                <h4>
                  {
                    <GetLanguageString props="transactions_infaq_to_cash_in_hand" />
                  }
                </h4>
              </Col>

              <Col xl="1" className="text-center">
                <Button
                  className="btn-info dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/addInfaqAmanatAccount`,
                    })
                  }
                >
                  <FaRegMoneyBill1 size={50} />
                </Button>
                <h4>
                  {
                    <GetLanguageString props="transactions_infaq_to_amanat_account" />
                  }
                </h4>
              </Col>

              <Col xl="1" className="text-center">
                <Button
                  className="btn-success dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/addBulkInfaq`,
                    })
                  }
                >
                  <FaMoneyBillWave size={50} />
                </Button>
                <h4>{<GetLanguageString props="funds_add_bulk_fund" />}</h4>
              </Col>

              <Col xl="1" className="text-center">
                <Button
                  className="btn-primary dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/manageIncome`,
                    })
                  }
                >
                  <BsWallet2 size={50} />
                </Button>
                <h4>{<GetLanguageString props="manage_income" />}</h4>
              </Col>
              <Col xl="1" className="text-center">
                <Button
                  className="btn-success dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/otherIncome`,
                    })
                  }
                >
                  <IoCashOutline size={50} />
                </Button>
                <h4>{<GetLanguageString props="funds_other_income" />}</h4>
              </Col>
              {unitTypeName === "Halqa" && (
                <Col xl="1" className="text-center">
                  <Button
                    className="btn-warning dim btn-large-dim"
                    onClick={() =>
                      history.push({
                        pathname: `/funds/otherIncomeLoanFromMarkaz`,
                      })
                    }
                  >
                    <IoCashOutline size={50} />
                  </Button>
                  <h4>
                    {
                      <GetLanguageString props="funds_other_income_loan_from_markaz" />
                    }
                  </h4>
                </Col>
              )}
              {unitTypeName === "Halqa" && (
                <>
                  <Col xl="1" className="text-center">
                    <Button
                      className="btn-primary dim btn-large-dim"
                      onClick={() =>
                        history.push({
                          pathname: `/funds/OtherIncomeTarbiatiCourseReimbursment`,
                        })
                      }
                    >
                      <IoCashOutline size={50} />
                    </Button>
                    <h4>
                      {
                        <GetLanguageString props="funds_other_income_tarbiati_course_reimbursment" />
                      }
                    </h4>
                  </Col>
                  <Col xl="1" className="text-center">
                    <Button
                      className="btn-success dim btn-large-dim"
                      onClick={() =>
                        history.push({
                          pathname: `/funds/otherIncomeHelpFromMuqamiTanzeem`,
                        })
                      }
                    >
                      <IoCashOutline size={50} />
                    </Button>
                    <h4>
                      {
                        <GetLanguageString props="funds_other_income_assistance_from_muqami_tanzeem" />
                      }
                    </h4>
                  </Col>
                </>
              )}
            </Row>
          </div>
        </div>
      </div>

      <div
        style={{ marginTop: "-50px", padding: "5px" }}
        className="wrapper wrapper-content wrapper-custom"
      >
        <div className="ibox">
          <div className="ibox-content panel-body">
            <h3>{<GetLanguageString props="sidebar_funds_expenses" />}</h3>

            <Row>
              <Col xl="1" className="text-center">
                    <Button
                      className="btn-success dim btn-large-dim"
                      onClick={() =>
                        history.push({
                          pathname: `/funds/expenseFromCashInHand`,
                        })
                      }
                    >
                      <IoCashOutline size={50} />
                    </Button>
                    <h4>
                      {
                        <GetLanguageString props="finance_expense_cash_in_hand" />
                      }
                    </h4>
                  </Col>
              <Col xl="1" className="text-center">
                    <Button
                      className="btn-info dim btn-large-dim"
                      onClick={() =>
                        history.push({
                          pathname: `/funds/expenseFromAmanat`,
                        })
                      }
                    >
                      <IoCashOutline size={50} />
                    </Button>
                    <h4>
                      {
                        <GetLanguageString props="finance_expense_amanat_account" />
                      }
                    </h4>
                  </Col>
              {unitTypeName === "Tanzeem" && (
                <Col xl="1" className="text-center">
                  <Button
                    className="btn-warning dim btn-large-dim"
                    onClick={() =>
                      history.push({
                        pathname: `/funds/expenseHalqaShare`,
                      })
                    }
                  >
                    <IoCashOutline size={50} />
                  </Button>
                  <h4>
                    {
                      <GetLanguageString props="funds_halqa_share" />
                    }
                  </h4>
                </Col>
              )}
              <Col xl="1" className="text-center">
                <Button
                  className="btn-primary dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/manageExpense`,
                    })
                  }
                >
                  <BsWallet2 size={50} />
                </Button>
                <h4>{<GetLanguageString props="manage_expense" />}</h4>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      <div
        style={{ marginTop: "-10px", padding: "5px" }}
        className="wrapper wrapper-content wrapper-custom"
      >
        <div className="ibox">
          <div className="ibox-content panel-body">
            <h3>{<GetLanguageString props="transfer" />}</h3>

            <Row>
              <Col xl="1" className="text-center">
                <Button
                  className="btn-warning dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/transferCashInHandToAmanat`,
                    })
                  }
                >
                  <FaMoneyBillTransfer />
                </Button>
                <h4>
                  {
                    <GetLanguageString props="transactions_cashinhand_to_amanat_account" />
                  }
                </h4>
              </Col>
              <Col xl="1" className="text-center">
                <Button
                  className="btn-danger dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/transferAmanatToCashInHand`,
                    })
                  }
                >
                  <FaMoneyBillTransfer />
                </Button>
                <h4>
                  {
                    <GetLanguageString props="transactions_amanat_to_cash_in_hand_account" />
                  }
                </h4>
              </Col>
              {unitTypeName === "Halqa" && (
                <Col xl="1" className="text-center">
                  <Button
                    className="btn-success dim btn-large-dim"
                    onClick={() =>
                      history.push({
                        pathname: `/funds/transferMarkazShare`,
                      })
                    }
                  >
                    <FaMoneyBillTransfer />
                  </Button>
                  <h4>
                    {
                      <GetLanguageString props="funds_markaz_share" />
                    }
                  </h4>
                </Col>
              )}
              <Col xl="1" className="text-center">
                <Button
                  className="btn-info dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/manageTransfer`,
                    })
                  }
                >
                  <FaExchangeAlt />
                </Button>
                <h4>
                  {<GetLanguageString props="transactions_manage_transfer" />}
                </h4>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(QuickManageFund);
